import { render, staticRenderFns } from "./TaskGeneralForm.vue?vue&type=template&id=b8d3b58e&lang=pug"
import script from "./TaskGeneralForm.vue?vue&type=script&lang=js"
export * from "./TaskGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports